'use strict';

var WebRemoting = require('../WebRemoting');
var Util = require('../Events/Util');
WebRemoting.require('ChartingService');

var Chart = function(chartDivId, isDashboardChart, isSidebar, mwml, chartData) {
    this.initialize(chartDivId, isDashboardChart, isSidebar, mwml, chartData);
};

Chart._uniquenessCounter = 0;

/* "static" div id uniquifier since charts that have the same dchart tag end up with the same div id */
Chart.uniqueifyDivId = function(div){
    div.id = div.id + '_' + Chart._uniquenessCounter++;
};


Chart.prototype = {

    chartDivId: null,
    mwml: '',

    blankChartMessageFontSize: '14px',
    blankChartMessageFontHeight: 19,

    noDataMessage: 'No data available',
    noDataMessageWidth:109,  // with the default highcharts settings, how wide is this message at blankChartMessageFontSize.

    fetchChartErrorMessage: 'Error getting data',
    fetchChartErrorMessageWidth:111,

    renderChartErrorMessage: 'Error showing chart',
    renderChartErrorMessageWidth:123,

    isDashboardChart: true,
    isSidebar: false,

    /*
     Public Methods
     */

    initialize: function(chartDivId, isDashboardChart, isSidebar, mwml, chartData){

        this.chartDivId = chartDivId;

        if(!(document.getElementById(this.chartDivId))) {
            console.error('Render-to div ' + this.chartDivId + ' not found');
            return false;
        }

        if( isDashboardChart ){
            this.isDashboardChart = isDashboardChart;
            this.isSidebar = isSidebar;
            this.mwml = mwml;

            if(isSidebar){
                Util.addElementVisibleEvent('dashboardResizeTab', function(){
                    if(chartData){
                        this.renderChart(chartData);
                    } else {
                        this.fetchDashboardChart();
                    }
                }.bind(this));
            } else {
                if(chartData){
                    this.renderChart(chartData);
                } else {
                    this.fetchDashboardChart();
                }
            }
        } else {
            this.isDashboardChart = false;
        }
    },

    fetchDashboardChart: function(){
        if(!this.isDashboardChart){
            return false;
        }
        var options = {
            callback: this.renderDashboardChartFromJson.bind(this),

            errorHandler: function(message, exception) {
                this.receiveChartFailureCallback('ERROR '+message , exception);
            }.bind(this),

            warningHandler: function(message, exception) {
                this.receiveChartFailureCallback('WARNING '+ message, exception);
            }.bind(this),

            exceptionHandler: function(message, exception) {
                this.receiveChartFailureCallback('EXCEPTION '+message, exception);
            }.bind(this)
        };

        // If we're in a sidebar, then we may not have enough room to display the chart at the requested dimensions.
        // Set the actual div height to be proportional to the actual width,
        // and report the width to the java side so it can do the same calculation for label rotation, etc.
        // Note these attributes are also examined by dashboardFrameWidthController when resizing the sidebar
        var actualWidth;
        var actualHeight;
        if(this.isSidebar){
            var $chartDiv = this._get$ChartDiv();
            actualWidth = $chartDiv.width();
            var requestedWidth = $chartDiv.attr('chartWidth');
            var requestedHeight = $chartDiv.attr('chartHeight');
            actualHeight = Math.floor(requestedHeight * (actualWidth/requestedWidth));
            $chartDiv.css({height: actualHeight + 'px'});
        }

        ChartingService.getDashboardChartJsonFromMwml(this.mwml, actualWidth, options);

    },

    _get$ChartDiv: function() {
        var escapedId =  this.chartDivId.replace( /(:|\.|\[|\]|,)/g, '\\$1' );
        return jQuery('#' + escapedId);
    },

    renderDashboardChartFromJson: function(chartDataJson) {
        this.renderChart(JSON.parse(chartDataJson));
    },

    /*
     * used by charts in dashboards and also the wizard
     */
    /* eslint-disable complexity */
    renderChart: function(chartData) {
        try{
            chartData.chart.renderTo = this.chartDivId;

            // test if there's no data returned, and just show an empty chart if so
            var hasData = false;
            var serieses = chartData.series;
            validateData:
                    for(var i = 0; i < serieses.length; i++){
                        var series = serieses[i];
                        if(series.data !== undefined && series.data.length > 0 ){
                            for(var j = 0; j < series.data.length; j++ ){
                                if( series.data[j] != null){
                                    if( typeof series.data[j] === 'number') {
                                        hasData = true;
                                        break validateData;
                                    } else if ( typeof series.data[j] === 'object' ){
                                        if( typeof series.data[j].y !== 'undefined' ){
                                            hasData = true;
                                        } else {
                                            // if data points don't have a y value at all set them to null
                                            series.data[j].y = null;
                                        }
                                    }
                                }
                            }
                        }
                    }

            if (! hasData ){
                var width = chartData.chart.width;
                var height = chartData.chart.height;
                chartData = this._getBlankChartConfiguration();
                var chartCallback = this._getBlankChartCallback(width, height, this.noDataMessage, this.noDataMessageWidth);

                new Highcharts.Chart(chartData, chartCallback);
                return;
            }

            // set the dimensions to zero so highcharts just fills the containing div, and
            // continues to use the size of the containing div while it is resized
            chartData.chart.width = null;
            chartData.chart.height = null; //note: if the height of the div is less than 20 then highcharts will default to 400.  Search for comment "the offsetHeight of an empty container is 0 in standard browsers, but 19 in IE7:"

            // turn the formatter function (if any) into a function.  Keep this in sync with renderSVG.js
            if( chartData.xAxis && chartData.xAxis.labels && chartData.xAxis.labels.formatter){
                chartData.xAxis.labels.formatter = new Function(chartData.xAxis.labels.formatter);
            }
            if( chartData.plotOptions.pie && chartData.plotOptions.pie.dataLabels.formatter){
                chartData.plotOptions.pie.dataLabels.formatter = new Function(chartData.plotOptions.pie.dataLabels.formatter);
            }
            if( chartData.plotOptions.series && chartData.plotOptions.series.dataLabels.formatter){
                chartData.plotOptions.series.dataLabels.formatter = new Function(chartData.plotOptions.series.dataLabels.formatter);
            }

            // hide drill down menu when clicking elsewhere on the chart
            if(!chartData.chart.events){ chartData.chart.events = {}; }
            chartData.chart.events.click = function() {
                hideCurrentMenu();
            };

            // doit
            var chart = new Highcharts.Chart(chartData);

        } catch (error){
            try{
                // attempt to show a chart saying we had trouble rendering the real chart.  Ignore errors.
                var width = this._get$ChartDiv().width();
                var height = this._get$ChartDiv().height();
                chartData = this._getBlankChartConfiguration();
                chartCallback = this._getBlankChartCallback(width, height, this.renderChartErrorMessage, this.renderChartErrorMessageWidth);
                console.error(error);

                new Highcharts.Chart(chartData, chartCallback);
            }catch(error2){
            }
        }

        return chart;
    },
    /* eslint-enable complexity */

    receiveChartFailureCallback: function(message, exception) {

        try{
            var $chartDiv = this._get$ChartDiv();
            var $parentDiv = $chartDiv.parent().parent();
            var commentNode;
            if ( this.isDashboardChart && exception.javaClassName === 'com.mits.discover.services.flashscreen.exceptions.SecurityIssueStructuredErrorException') {
                // entirely hidden by security
                commentNode = document.createComment('Chart removed: ' + message);
                $parentDiv.empty();
                $parentDiv.append(commentNode);
            } else {
                console.error('Error fetching chart data.  Message: ' + message + ' Exception: ' + dwr.util.toDescriptiveString(exception, 2));
                // attempt to show a chart saying we had trouble getting the real chart data.
                var width = $chartDiv.width();
                var height = $chartDiv.height();
                var chartData = this._getBlankChartConfiguration();
                var chartCallback = this._getBlankChartCallback(width, height, this.fetchChartErrorMessage, this.fetchChartErrorMessageWidth);
                // un-hide header and footer since we have data
                var $siblings = $chartDiv.parent().children();
                $siblings.removeClass('invisible');
                new Highcharts.Chart(chartData, chartCallback);
                commentNode = document.createComment(message);
                $parentDiv.append(commentNode);
            }
        }catch(error2){
            console.error('error trying to handle an error ' + error2);
        }
    },

    _getBlankChartConfiguration : function(){
        return {
            chart: {
                renderTo: this.chartDivId,
                type:'column'
            },
            title:{ text:'' },
            credits:{ enabled: false },
            tooltip:{ enabled: false },
            xAxis: {
                lineWidth: 1,
                categories: [],
                labels:{ enabled: false }
            },
            yAxis:{
                gridLineColor: null,
                lineWidth: 1,
                labels:{ enabled: false },
                title:{ text:'' }
            },
            legend:{ enabled: false },
            series: [{data:[0]}]
        };
    },

    _getBlankChartCallback:function(width, height, message, messageWidth){

        var x = width/2 - messageWidth/2;
        var y = height/2;
        var font = this.blankChartMessageFontSize;

        // this will be called on complete, to add text to the chart via its renderer
        return function(chart) {
            chart.renderer.text(message,x, y)
                    .css({
                        color: '#4572A7',
                        fontSize: font
                    })
                    .add();
        };
    }
};

module.exports = Chart;


//////////////////
// WEBPACK FOOTER
// ./mits/Widgets/Chart.js
// module id = 30
// module chunks = 0